module.exports = __webpack_public_path__ + "assets/img/main-logo-tangshan.ffb14400.png";